import { StringBase } from '../StringBase';

export class PublisherNotes extends StringBase {}
